/* 迁移'@/pages/dashboard/components/Abnormal'组件并作修改
 * @Description: 异常组件封装，包括加载中，加载失败，无数据组件等
 */
import React from "react";
import { useIntl } from 'umi';
import Loading from "@/pages/dashboard/components/Loading";
import NoData from "@/pages/dashboard/components/NoData";
import LoadingFailed from "@/pages/dashboard/components/LoadingFailed";

type Node = React.Component | React.ReactNode | string
export interface AbnormalPropsFace {
  isLoading: boolean;
  componentLoading?: boolean;
  isError?: boolean;
  isNoData?: boolean;
  loadingMsg?: string;
  failedMsg?: string;
  nodataMsg?: Node;
  component?: any;
  style?: any;
  classNames?: string;
}

const Abnormal = (props: AbnormalPropsFace) => {
  const { formatMessage } = useIntl();
  const {
    isLoading = true,
    componentLoading = false,
    isError = false,
    isNoData = false,
    loadingMsg = formatMessage({ id: 'common_loading' }),
    failedMsg = formatMessage({ id: 'common_loading_failed' }),
    nodataMsg = formatMessage({ id: 'common_nodata' }),
    component,
    style,
    classNames
  } = props;

  if (isLoading) {
    return (
      <div className={classNames} style={{
        height: 300,
        color: '#444',
        ...style,
      }}>
        <Loading content={loadingMsg} />
      </div>
    );
  }
  if (isError) {
    return <div className={classNames} style={{
      height: 300,
      color: '#444',
      ...style,
    }}><LoadingFailed failedMsg={failedMsg} /></div>;
  }
  if (isNoData && (!componentLoading)) {
    return <div className={classNames} style={{
      height: 300,
      color: '#444',
      ...style,
    }}><NoData text={nodataMsg} /></div>;
  }

  return (
    <>
      {
        componentLoading && (
          <div className={classNames} style={{
            height: 300,
            color: '#444',
            ...style,
          }}>
            <Loading content={loadingMsg} />
          </div>
        )
      }
      {/** 不要用div包裹，会影响样式 */}
      {componentLoading ? null : component}
    </>
  );

};

export default Abnormal;

